<!--
 @description dashboard
 @author xiehan
 @date 2018/9/19
-->
<style>

</style>

<template>
  <div>
    dashBoard
  </div>
</template>
<script>

export default {
  data () {
    return {
    }
  },
  components: {
  },
  methods: {

  },
  mounted () {

  }
}
</script>
